<template>
  <v-app id="inspire"  class="c-bg-gray">
    <v-main class="tw-w-full">
      <v-container class="fill-height" fluid >
        <v-col cols="12" class="col-md-10 offset-md-1 col-sm-12 tw-mt-5 md:tw-mt-0">
          <v-row
          align="center"
          justify="center"
        >
          <v-col id="forgot-password" cols="12" sm="8" md="5">
            <v-card class="elevation-3">
              <div class="tw-w-full tw-flex tw-justify-center">
                <img src="/pacis-logo.png" class="tw-w-24 md:tw-w-32 tw-mt-4 md:tw-mt-6" alt="logo">
              </div>
              <v-card-text class="tw-px-4 md:tw-px-10">
                <div class="tw-w-full tw-text-center tw-mt-6">
                  <h2 class="c-blue-text c-title title">Reset Password</h2>
                  <p class="tw-mt-2 tw-pb-4">Please check your email/phone for a link/ OTP to help you reset your password</p>
                </div>
                <v-form v-model="isValid">
                  <v-text-field
                    id="email"
                    label="Email"
                    type="email"
                    v-model="email"
                    :rules="[required('Email'), emailFormat()]"
                  >
                    <v-icon slot="prepend" color="primary">mdi-email</v-icon>
                  </v-text-field>
                </v-form>
              </v-card-text>
               <v-card-actions class="px-10">
                    <v-spacer></v-spacer>
                    <v-btn
                        id="submit"
                      block
                      large
                      color="secondary"
                      class="my-2"
                      :loading="loading"
                      :disabled="!isValid"
                      @click="onReset">
                      Request Reset Link
                    </v-btn>
                </v-card-actions>
              <v-card-actions class="tw-w-full tw-flex justify-center tw-pb-10">
                <span class="c-gray-text body-2" >Already Have an account ? <router-link class="tw-font-bold" :to="{ name: 'SignIn' }">Sign In</router-link> </span>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        </v-col>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>

import validations from '@/utils/validations';
import { mapGetters } from 'vuex';
// import { FB_RESET_PASS_INIT } from '@/utils/const';

export default {
  metaInfo: {
    title: 'Forgot Password',
  },
  props: {
    source: String,
  },
  data() {
    return {
      email: '',
      ...validations,
      loading: false,
      isValid: false,
    };
  },
  computed: {
    ...mapGetters('auth', ['hasAuthenticationStatus', 'authenticationStatus']),
  },
  mounted() {
    this.$store.dispatch('auth/clearAuthenticationStatus');
  },
  methods: {
    async onReset() {
      this.loading = true;
      try {
        const res = await fetch(
          `${process.env.VUE_APP_AUTH_API}/auth/forgot-password`,
          {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ email: this.email }),
          },
        );

        const data = await res.json();

        if (!res.ok) {
          this.$toast.error(data.message || 'Request failed', 'Error');
          return;
        }

        this.$toast.success(data.message, 'Check your email');
        this.$router.push({
          name: 'ResetPassword',
          query: { user: this.email },
        });
      } catch (err) {
        this.$toast.error('Network error. Please try again.', 'Error');
      } finally {
        this.loading = false;
      }
    },
  },

};
</script>
